import CompanyData from "assets/files/Companies.json";

export function GetCompanyData() {
    return CompanyData;
}